import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Stack,
  css,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { staticFileLocation } from '@server/constants';
import theme from '@styles/theme';
import { Close } from '@mui/icons-material';

type NoCompensationWarningModalProps = {
  open: boolean;
  handleEdit: () => void;
  handleSave: () => void;
};

const recruiterLogos = [
  `${staticFileLocation}img/logos/zip-recruiter.jpg`,
  `${staticFileLocation}img/logos/GoogleJobs.jpg`,
  `${staticFileLocation}img/logos/indeed.png`,
];

const NoCompensationWarningModal: React.FC<NoCompensationWarningModalProps> = ({
  open,
  handleEdit,
  handleSave,
}) => {
  return (
    <Dialog open={open} onClose={handleEdit} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleEdit}
        >
          <Close />
        </IconButton>
        <br />
        <Stack
          gap={1}
          direction="row"
          spacing={1}
          justifyContent="center"
          alignItems="center"
          mb={2}
        >
          <img
            src={`${staticFileLocation}img/logos/LogoStampShadow.png`}
            css={css`
              max-width: 50px;
              width: 100%;
              margin-right: ${theme.spacing(2)};
              margin-top: 20px;
            `}
            alt="Notifications"
          />
          <Typography variant="h4" fontWeight="bold" color="#00AEEF" mb={1}>
            +
          </Typography>

          <Stack
            direction="column"
            spacing={1}
            alignItems="center"
            justifyContent="center"
            mb={2}
          >
            {recruiterLogos.map((src, index) => (
              <img
                src={src}
                css={css`
                  max-width: 50px;
                  width: 100%;
                `}
              />
            ))}
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pt: 4 }}>
        <Typography variant="h2" sx={{ fontWeight: 900 }} color="#008fcc">
          Heads Up!
        </Typography>
        <Typography variant="body1" mt={2} color="gray" fontSize={18}>
          Adding compensation is <strong>mandatory</strong> for <br /> many of
          the job boards including Zip &amp; <br /> Indeed, &amp; will help your
          jobs get seen more!
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3, mb:3 }}>
        <Button
          variant="contained"
          onClick={handleEdit}
          sx={{ textTransform: 'none', width: '170px' }}
        >
          Add Compensation
        </Button>
        <Button
          variant="outlined"
          onClick={handleSave}
          sx={{ textTransform: 'none', width: '170px' }}
        >
          Save My Job
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoCompensationWarningModal;
